export default __webpack_public_path__ + "static/media/k2.08b8c652.png";